import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-sale-print',
  templateUrl: './sale-print.component.html',
  styleUrls: ['./sale-print.component.scss']
})
export class SalePrintComponent implements OnInit, OnDestroy {
  public isOnline: any | undefined;
  public loading = false;
  public subscription: Subscription | any;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any = this.serverService.get_server();
  id: number;
  weight2: number;
  mv: number;
  design: number;
  design_all: number;
  mwf2: number;
  mwf: number;
  price_lsf: number;
  install: number;
  install1: number;
  install2: number;
  price_all1: number;
  wast: number;
  price_all_without_discount: number;
  price_all_without_discount_m2: number;
  price_all: number;
  price_all_m2: number;
  percent: number;
  price_final: number;
  crater_title: string;
  type_ceil_title: string;
  tip_title: string;
  position_title: string;
  site_title: string;
  open_crater_title: string;
  height_title: string;
  place_title: string;
  discount_all: number | undefined;

  shop_title: string;
  cellphone: string;
  user_title: string;
  date: string;
  code_factor: string;
  contract: string;
  product: any;
  bana_all: number;
  address: string;
  discount: number;
  discount_festival_price: number;
  discount_festival: number;
  tax_check_value: number;
  arch1: number;
  arch2: number;
  floor_title: string;
  code: number;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any
    , private matDialogRef: MatDialogRef<SalePrintComponent>
  ) {
    if (dialog_data) {
      this.id = dialog_data.id;
    }
  }//end consructor

  ngOnInit() {
    this.get_data();
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1504, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.product = res['result'][0].pre_factor_lsf_order_product;
          this.address = res['result'][0].pre_factor_lsf_order_address;
          this.floor_title = res['result'][0].shop_shop_floor_title;

          this.weight2 = res['result'][0].pre_factor_lsf_order_weight2;
          this.mv = res['result'][0].pre_factor_lsf_order_mv;
          this.design = res['result'][0].pre_factor_lsf_order_design;
          this.design_all = res['result'][0].pre_factor_lsf_order_design_all;
          this.mwf2 = res['result'][0].pre_factor_lsf_order_mwf2;
          this.mwf = res['result'][0].pre_factor_lsf_order_mwf;
          this.price_lsf = res['result'][0].pre_factor_lsf_order_price_lsf;
          this.install = res['result'][0].pre_factor_lsf_order_install;
          this.install1 = res['result'][0].pre_factor_lsf_order_install1;
          this.install2 = res['result'][0].pre_factor_lsf_order_install2;


          this.price_all1 = res['result'][0].pre_factor_lsf_order_price_all1;
          this.wast = res['result'][0].pre_factor_lsf_order_wast;
          this.price_all_without_discount = res['result'][0].pre_factor_lsf_order_price_all_without_discount;
          this.price_all_without_discount_m2 = res['result'][0].pre_factor_lsf_order_price_all_without_discount_m2;
          this.price_all = res['result'][0].pre_factor_lsf_order_price_all;
          this.price_all_m2 = res['result'][0].pre_factor_lsf_order_price_all_m2;
          this.percent = res['result'][0].pre_factor_lsf_order_percent;
          this.price_final = res['result'][0].pre_factor_lsf_order_price_final;
          this.discount_festival_price = res['result'][0].pre_factor_lsf_order_discount_festival;
          this.discount_festival = res['result'][0].pre_factor_lsf_order_discount_festival;
          this.discount = res['result'][0].pre_factor_lsf_order_discount;
          this.tax_check_value = res['result'][0].pre_factor_lsf_order_tax_check_value;

          this.discount_all = Number(this.mwf * this.discount_festival_price / 100) + Number(this.discount)

          this.bana_all = res['result'][0].pre_factor_lsf_order_meter;
          this.arch1 = res['result'][0].pre_factor_lsf_order_arch1;

          this.crater_title = res['result'][0].shop_crater_title;
          this.type_ceil_title = res['result'][0].shop_type_ceil_title;
          this.tip_title = res['result'][0].shop_tip_title;
          this.position_title = res['result'][0].shop_install_run_position_title;
          this.site_title = res['result'][0].shop_install_site_title;
          this.open_crater_title = res['result'][0].shop_install_open_crater_title;
          this.height_title = res['result'][0].shop_install_height_title;
          this.place_title = res['result'][0].shop_install_place_title;

          this.shop_title = res['result'][0].shop_menu_shop_title;
          this.cellphone = res['result'][0].user_cellphone;
          this.user_title = res['result'][0].user_title;
          this.date = res['result'][0].pre_factor_lsf_order_date;
          this.code_factor = res['result'][0].pre_factor_lsf_order_code_factor;
          this.contract = res['result'][0].pre_factor_lsf_order_contract;



          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
